import { useToast } from "@/composables/useToast.js";

export function useHttpErrorManager() {
	const handleError = async (error, showToast = false) => {
		let errorFields = {}

		let message = error.message
		let error_message = ""
		// let err_404 = false

		if (error.response !== undefined && error.response.status !== undefined && error.response.status === 422) {
			let error_set = error.response.data.errors
			if (error_set) {
				error_set = Object.entries(error_set)
				error_set.forEach(errorItem => {
					errorFields[errorItem[0]] = errorItem[1][0]
				})
			}
			error_message = error.response.data.message
		} 
        else if ( error.response !== undefined && error.response.status !== undefined && error.response.data !== undefined ) {
			error_message = error.response.data.message
		}

		if (error.response !== undefined && error.response.data !== undefined && error.response.data.message !== undefined && error.response.data.title !== undefined ) {
			error_message = error.response.data.message
		}
		
		let temp_message = "";
		if (error_message !== undefined || error_message !== null || error_message !== "" ) {
			errorFields["err_message"] = error_message
			temp_message = error_message;
		}

		if (message !== undefined || message !== null || message != "") {
			errorFields["alt_message"] = message
			temp_message += "\n" + message;
		}
		
		errorFields["full_message"] = temp_message
		
		if (showToast) {
			useToast().displayToast(errorFields["full_message"], "outline-danger", 8000);
		}

		// if (err_404) {
		// 	useHelperStore().change404State(true)
		// }

		return errorFields;
	}

	return {
		handleError
	}
}